var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5557_42384)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.225586,
    width: 50,
    height: 37,
    rx: 5,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 0.225586H50.6758V17.4923H0.675781V0.225586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.675781 0.225586L24.4853 18.7256L0.675781 37.2256V0.225586Z",
    fill: "#1A47B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5557_42384"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.675781,
    y: 0.225586,
    width: 50,
    height: 37,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechRepublic);
export default __webpack_public_path__ + "static/media/CzechRepublic.25de976ceb7a8049ba966ba53f49b740.svg";
export { ForwardRef as ReactComponent };